/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type { Staking, StakingInterface } from "../Staking";

const _abi = [
  {
    inputs: [],
    name: "InsufficientAmount",
    type: "error",
  },
  {
    inputs: [],
    name: "InsufficientBalance",
    type: "error",
  },
  {
    inputs: [],
    name: "InsufficientFee",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidExchangeRateReceived",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "messengerId",
        type: "uint256",
      },
    ],
    name: "MessengerNotEnabled",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "messengerId",
        type: "uint256",
      },
    ],
    name: "MessengerNotFound",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "UnauthorizedCall",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroMessengers",
    type: "error",
  },
  {
    inputs: [],
    name: "contractPaused",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "block",
        type: "uint256",
      },
    ],
    name: "ContractPaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "block",
        type: "uint256",
      },
    ],
    name: "ContractUnPaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stkEthAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sourceChainId",
        type: "uint256",
      },
    ],
    name: "EthReceived",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "messengerId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "messenger",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isEnabled",
        type: "bool",
      },
    ],
    name: "MessengerAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "messengerId",
        type: "uint256",
      },
    ],
    name: "MessengerDisabled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "messengerId",
        type: "uint256",
      },
    ],
    name: "MessengerEnabled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_pendingValidatorsLimit",
        type: "uint256",
      },
    ],
    name: "SetPendingValidatorsLimit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldReceiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newReceiver",
        type: "address",
      },
    ],
    name: "SocketReceiverChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "block_time",
        type: "uint256",
      },
    ],
    name: "Stake",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "messengerId",
        type: "uint256",
      },
    ],
    name: "TransferredToL2",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_pendingValidators",
        type: "uint256",
      },
    ],
    name: "UpdatePendingValidators",
    type: "event",
  },
  {
    inputs: [],
    name: "DEPOSIT_CONTRACT",
    outputs: [
      {
        internalType: "contract IDepositContract",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "VALIDATOR_DEPOSIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "VERIFICATION_DEPOSIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "WETH",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "messenger",
            type: "address",
          },
          {
            internalType: "bool",
            name: "isEnabled",
            type: "bool",
          },
        ],
        internalType: "struct Issuer.MessengerData[]",
        name: "_messengers",
        type: "tuple[]",
      },
    ],
    name: "addMessenger",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "core",
    outputs: [
      {
        internalType: "contract ICore",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "publicKey",
        type: "bytes",
      },
    ],
    name: "depositToEth2",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "depositedValidators",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_messengerId",
        type: "uint256",
      },
    ],
    name: "disableMessenger",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_messengerId",
        type: "uint256",
      },
    ],
    name: "enableMessenger",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "ethStaked",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stkEthMinted",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_sourceChainId",
        type: "uint256",
      },
    ],
    name: "getDepositL2",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_messengerId",
        type: "uint256",
      },
    ],
    name: "getMessenger",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getNumberMessengers",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ICore",
        name: "_core",
        type: "address",
      },
      {
        internalType: "address",
        name: "_depositContract",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_depositedValidators",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_ethStaked",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_ethMinted",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "messengers",
    outputs: [
      {
        internalType: "address",
        name: "messenger",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isEnabled",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_messengerId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_callValue",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_receiverAddress",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "_payload",
        type: "bytes",
      },
    ],
    name: "mintL2",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_messengerId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_receiverAddress",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "_payload",
        type: "bytes",
      },
    ],
    name: "mintWethL2",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newReceiver",
        type: "address",
      },
    ],
    name: "setSocketReceiver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "socketReceiver",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stake",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "stakeWeth",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "stkEthMinted",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_messengerId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_receiverAddress",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "_payload",
        type: "bytes",
      },
    ],
    name: "transferToL2",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type StakingConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: StakingConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Staking__factory extends ContractFactory {
  constructor(...args: StakingConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<Staking> {
    return super.deploy(overrides || {}) as Promise<Staking>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): Staking {
    return super.attach(address) as Staking;
  }
  override connect(signer: Signer): Staking__factory {
    return super.connect(signer) as Staking__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): StakingInterface {
    return new utils.Interface(_abi) as StakingInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Staking {
    return new Contract(address, _abi, signerOrProvider) as Staking;
  }
}
